import React, { useRef, useState } from "react";
import { format, parseJSON } from "date-fns";
import CreditLevelActionsModal from "./CreditLevelActionsModal";
import { handleStatusExtra } from "../../helperFunctions/helpers";
import { buildName, Singleton } from "helper/tools";

export default function CreditLevelTable({
  items,
  tryApprove,
  openItem,
  reloadCredit,
}) {
  const creditLevelActionsModalRef = useRef();

  const [item, setItem] = useState({});

  //const OpStatus = makeEnum(["Aprobado", "Pendiente", "Cancelado"]);
  /*
  class OpStatus {
    // Private Fields
    static #_RED = 0;
    static #_GREEN = 1;
    static #_BLUE = 2;

    // Accessors for "get" functions only (no "set" functions)
    static get RED() { return this.#_RED; }
    static get GREEN() { return this.#_GREEN; }
    static get BLUE() { return this.#_BLUE; }
}*/
  /*
let OpStatus = {};
dictionary.Aprobado = "success";
dictionary.Pendiente = "warning";
dictionary.Cancelado = "danger";*/

  const tryApprove1 = async (newItem) => {
    /*let response = await pagoniApproveResetPassword(item.username).catch(
      (e) => {}
    );
    if (!response) return;
    fetchData();*/

    setItem(newItem);
    creditLevelActionsModalRef.current.toggleModal();

    console.log("-->");
  };

  /*
  const StatusToStyles = {
    Aceptado: "success",
    Pendiente: "warning",
    Declinado: "danger",
  };*/

  /*
  function reloadCredit() {
    fetchData();
  }
*/
  return (
    <>
      <CreditLevelActionsModal
        ref={creditLevelActionsModalRef}
        item={item}
        reloadCredit={reloadCredit}
      />

      <table className="table table-borderless datable">
        <thead className="table-light" style={{ textAlign: "center" }}>
          <tr>
            <th scope="col" style={{ width: "180px" }}>
              Fecha
            </th>
            {/*<th scope="col">Username</th>*/}
            <th scope="col">Nombre</th>
            <th scope="col">Tipo</th>
            <th scope="col">Acciones</th>
          </tr>
        </thead>
        <tbody style={{ textAlign: "center" }}>
          {items &&
            items.length > 0 &&
            items.map((item) => {
              const nombre = [
                item.asociadoNombre ?? "",
                item.asociadoApellidoPaterno ?? "",
                item.asociadoApellidoMaterno ?? "",
              ].join(" ");

              const operacion = item.tipoDeSolicitud;
              const status = item.tipoDeAccion; //makeEnum(operacion.status);
              const solicitante = buildName(item.usuarioCreador, true);

              let notas = "";
              let title = "";
              let descripcion = "";

              /*
              const mode = !item.congelado ? "Congelar" : "Descongelar";
                    const text = !item.congelado ? "Congelado" : "Descongelado";
                    */

              if (operacion === "LimiteCredito") {
                const newValueRaw = item.limiteCreditoSolicitado;
                const creditoActualRaw = item.limiteCreditoActual;
                const newValue = newValueRaw.toLocaleString("en-US");

                const formattedCredito = Singleton.getInstance().format(
                  item.asociadoCredito,
                );
                // falta
                const value = creditoActualRaw.toLocaleString("en-US");
                //const creditoActual = creditoActualRaw.toLocaleString("en-US");
                title = `Limite Credito: De $${value} a $${newValue}`;

                descripcion = `Dispuesto: ${formattedCredito}`;
                notas = `Nota: ${item.mensaje}`;
              } else if (operacion === "Nivel") {
                const nivelActual = item.nivelActualNombre;
                const nivelNuevo = item.nivelSolicitadoNombre;

                title = `Nivel: De ${nivelActual} a ${nivelNuevo}`;

                //descripcion = `Actual: $${creditoActual}`;
                descripcion = ``;
                notas = `Nota: ${item.mensaje}`;
              } else if (
                operacion === "Congelar" ||
                operacion === "Descongelar"
              ) {
                title = `A: `;

                //descripcion = `Actual: $${creditoActual}`;
                descripcion = `${operacion}`;
                notas = `Nota: ${item.mensaje}`;
              }

              const utcDate = parseJSON(item.fecha);
              const date = format(utcDate, "dd/MM/yy hh:mm a");

              return (
                <tr key={item.id}>
                  <td>{date}</td>
                  <th scope="row">
                    {/* <a href="#" onClick={(e) => openItem(item)}> */}
                    {nombre}
                    <div>
                      {" "}
                      <span className="fw-normal">Solicita:</span> {solicitante}
                    </div>
                    {/*</a>*/}
                  </th>
                  <td>
                    <div
                      className="list-group-item justify-content-between align-items-start"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title={notas}
                    >
                      <div className="ms-2 me-auto">
                        <div className="fw-bold">{title}</div>
                        {descripcion}
                      </div>
                      <span className="badge bg-primary rounded-pill"></span>
                    </div>
                  </td>
                  <td>
                    <button
                      type="button"
                      className={`btn btn-sm btn-${handleStatusExtra(status)}`}
                      onClick={(e) => tryApprove1(item)}
                    >
                      {status}
                    </button>
                    {/* <a href="#" onClick={(e) => tryApprove(item)}>
                    Aprobar
                  </a>*/}
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
    </>
  );
}
